const literal = (str: string): string => {
  return str.charAt(0).toUpperCase();
};
const declensionOfNum = (
  number: number | undefined,
  titles: string[],
): string | void => {
  if (!number) {
    return;
  }

  const cases = [2, 0, 1, 1, 1, 2];
  const n: number = Math.abs(number);

  return titles[
    n % 100 > 4 && n % 100 < 20 ? 2 : cases[n % 10 < 5 ? n % 10 : 5]
  ];
};

export { literal, declensionOfNum };
